/* The small behaviours the shop's pages share: rails that scroll by their arrows, the "Try a name"
   switch between signs, keychains and magnets, and the phone's "See all" for the bands. */
(function () {
  function arrows(section) {
    const prev = section.querySelector('[data-rail-prev]');
    const next = section.querySelector('[data-rail-next]');
    if (!prev || !next) return;
    const rail = () => [...section.querySelectorAll('[data-rail]')].find((r) => !r.hidden);
    const sync = () => {
      const r = rail();
      if (!r) return;
      prev.disabled = r.scrollLeft <= 2;
      next.disabled = r.scrollLeft + r.clientWidth >= r.scrollWidth - 2;
    };
    const step = (direction) => {
      const r = rail();
      if (r) r.scrollBy({left: direction * r.clientWidth, behavior: 'smooth'});
    };
    prev.addEventListener('click', () => step(-1));
    next.addEventListener('click', () => step(1));
    section.querySelectorAll('[data-rail]').forEach((r) => r.addEventListener('scroll', sync, {passive: true}));
    addEventListener('resize', sync);
    section.addEventListener('il-rail-change', sync);
    sync();
  }
  document.querySelectorAll('[data-rail-section]').forEach(arrows);

  document.querySelectorAll('[data-kind-chips]').forEach((chips) => {
    const section = chips.closest('[data-rail-section]');
    chips.addEventListener('click', (event) => {
      const chip = event.target.closest('[data-kind]');
      if (!chip) return;
      chips.querySelectorAll('[data-kind]').forEach((c) => c.setAttribute('aria-pressed', String(c === chip)));
      section.querySelectorAll('[data-rail]').forEach((r) => { r.hidden = r.dataset.rail !== chip.dataset.kind; });
      section.dispatchEvent(new CustomEvent('il-rail-change'));
    });
  });

  document.querySelectorAll('[data-see-all]').forEach((button) => {
    button.addEventListener('click', () => {
      button.previousElementSibling.classList.add('open');
      button.hidden = true;
    });
  });
})();
